function formatOffset(value: number): string {
  return `${value.toFixed(1)}`;
}

function buildConvoluteSample(
  size: number,
  row: number,
  column: number,
  opaque: boolean,
): string {
  const halfSize = (size - 1) / 2;
  const xOffset = formatOffset(column - halfSize);
  const yOffset = formatOffset(row - halfSize);
  const matrixIndex = row * size + column;
  const sampler = `texture2D(uTexture, vTexCoord + vec2(uStepW * ${xOffset}, uStepH * ${yOffset}))`;

  if (opaque) {
    return `color += ${sampler} * uMatrix[${matrixIndex}];`;
  }

  return `color.rgb += ${sampler}.rgb * uMatrix[${matrixIndex}];`;
}

function buildConvoluteFragmentSource(size: number, opaque: boolean): string {
  const samples: string[] = [];

  for (let row = 0; row < size; row += 1) {
    for (let column = 0; column < size; column += 1) {
      samples.push(buildConvoluteSample(size, row, column, opaque));
    }
  }

  const colorInitializer = opaque
    ? 'vec4 color = vec4(0.0, 0.0, 0.0, 0.0);'
    : 'vec4 color = vec4(0.0, 0.0, 0.0, 1.0);';
  const finalize = opaque
    ? 'gl_FragColor = color;'
    : [
        'float alpha = texture2D(uTexture, vTexCoord).a;',
        'gl_FragColor = color;',
        'gl_FragColor.a = alpha;',
      ].join('\n      ');

  return `
    precision highp float;
    uniform sampler2D uTexture;
    uniform float uMatrix[${size * size}];
    uniform float uStepW;
    uniform float uStepH;
    varying vec2 vTexCoord;
    void main() {
      ${colorInitializer}
      ${samples.join('\n      ')}
      ${finalize}
    }
    `;
}

export const fragmentSource = {
  Convolute_3_1: buildConvoluteFragmentSource(3, true),
  Convolute_3_0: buildConvoluteFragmentSource(3, false),
  Convolute_5_1: buildConvoluteFragmentSource(5, true),
  Convolute_5_0: buildConvoluteFragmentSource(5, false),
  Convolute_7_1: buildConvoluteFragmentSource(7, true),
  Convolute_7_0: buildConvoluteFragmentSource(7, false),
  Convolute_9_1: buildConvoluteFragmentSource(9, true),
  Convolute_9_0: buildConvoluteFragmentSource(9, false),
} as const;
